export const DIACRITIC_INSENSITIVE_CONTAINS = 'diacriticInsensitiveContains';
// PrimeNG supports registered modes at runtime, but its input type only lists built-in modes.
export const PRIMENG_DIACRITIC_INSENSITIVE_CONTAINS = DIACRITIC_INSENSITIVE_CONTAINS as 'contains';

export function normalizeSearchText(value: unknown): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['"‘’‛′ʼ´“”]/gu, '')
    .toLowerCase();
}

export function containsNormalizedText(value: unknown, filter: unknown): boolean {
  const normalizedFilter = normalizeSearchText(filter).trim();

  return !normalizedFilter || normalizeSearchText(value).includes(normalizedFilter);
}
